export const addTargetToLinks = (html) => {
    return html && html.replace(/<a\s+href="([^"]+)"/g, (match, url) => {
        const excludedDomains = [
            'http://boosthive.eu',
            'https://boosthive.eu',
            'boosthive.eu'
        ];

        const isRelative = url.startsWith('/');

        if (excludedDomains.some(domain => url.includes(domain)) || isRelative) {
            return match;
        }

        return `<a href="${url}" target="_blank"`;
    });
};


// WEBPACK FOOTER //
// ./utils/addTargetToLinks.js